import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { ActiveTabEnum, AudioEnum } from "../../../enums";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setSpinAgainTimeout } from "../../../store/picks/tabs-slice";
import { store } from "../../../store/store";
import CountWrapper from "./CountWrapper";
import { playAudioEffect } from "../../../store/audio-slice";
// eslint-disable-next-line max-len
import AudioPlayerNonInteractiveEffect from "../../Common/AudioPlayer/AudioEffect/AudioPlayerNonInteractiveEffect";
import { getAudio } from "../../../utils/AudioUtils";

interface Props {
  cancelDrawStart: (isPlay: boolean) => void;
  createTicket: () => Promise<void>;
}

const Countdown: React.FC<Props> = ({ cancelDrawStart, createTicket }) => {
  const countdownTimeout = useAppSelector(
    (state) => state.config.countdownTimeout
  );
  const [counter, setCounter] = useState(countdownTimeout / 1000);
  const gameType = useAppSelector((state) => state.config.gameType);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const countdown = setTimeout(async () => {
      if (counter === 0) {
        await createTicket();
        cancelDrawStart(false);
      }

      if (counter > 0) {
        setCounter((prevState) => prevState - 1);
      }
    }, 1000);

    return () => clearTimeout(countdown);
  }, [counter, gameType, cancelDrawStart, createTicket, dispatch]);

  useEffect(() => () => cancelDrawStart(false), [cancelDrawStart]);

  const undoClickHandler = (): void => {
    if (store.getState().tab.activeTab === ActiveTabEnum.DRAW) {
      dispatch(setSpinAgainTimeout(3));
    }

    cancelDrawStart(false);
  };

  return createPortal(
    <div className="overlay">
      <div className="overlay_countdown">
        <CountWrapper classWrap={`wrap-${counter}`} />
        <svg>
          <defs>
            <filter id="filter">
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="18"
                result="blur"
              />
              <feColorMatrix
                in="blur"
                mode="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10"
                result="filter"
              />
              <feComposite in="SourceGraphic" in2="filter" operator="atop" />
            </filter>
          </defs>
        </svg>

        {counter >= 1 && (
          <button
            type="button"
            className="overlay_button"
            onClick={() => {
              undoClickHandler();
              dispatch(playAudioEffect(AudioEnum.EFFECT_UNDO));
            }}
          >
            {t("panel.bettingPanel.undoBet")}
          </button>
        )}
      </div>
      <AudioPlayerNonInteractiveEffect
        audioEffectToBePlayed={getAudio(AudioEnum.EFFECT_COUNTDOWN)}
      />
    </div>,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.getElementById("overlay-root")!
  );
};

export default Countdown;
